import IndexMain from 'components/index/IndexMain';
import Layout from 'components/layout/Layout';
import { FC } from 'react';

const IndexPage: FC = () => {
  return (
    <Layout>
      <IndexMain />
    </Layout>
  );
};

export default IndexPage;
